import { render } from "./StakeSOLDialog.vue?vue&type=template&id=d636a724&scoped=true&ts=true"
import script from "./StakeSOLDialog.vue?vue&type=script&lang=ts"
export * from "./StakeSOLDialog.vue?vue&type=script&lang=ts"

import "./StakeSOLDialog.vue?vue&type=style&index=0&id=d636a724&scoped=true&lang=scss"
import "./StakeSOLDialog.vue?vue&type=style&index=1&id=d636a724&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d636a724"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QInput,QSlider,QField});qInstall(script, 'directives', {ClosePopup});
